import { render, staticRenderFns } from "./LoadingSpinner.vue?vue&type=template&id=0a74a980&scoped=true"
import script from "./LoadingSpinner.vue?vue&type=script&lang=ts"
export * from "./LoadingSpinner.vue?vue&type=script&lang=ts"
import style0 from "./LoadingSpinner.vue?vue&type=style&index=0&id=0a74a980&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a74a980",
  null
  
)

export default component.exports